import { render, staticRenderFns } from "./BaseLayoutAdmin.vue?vue&type=template&id=0dc39502&"
import script from "./BaseLayoutAdmin.vue?vue&type=script&lang=js&"
export * from "./BaseLayoutAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports